class Stepper {
  constructor(el) {
    this.el = el
    this.min = 5
    this.max = 15
    this.inc = 5
    this.translate = 80
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$minus = this.el.querySelector('.js-stepper-minus')
    this.ui.$plus = this.el.querySelector('.js-stepper-plus')
    this.ui.$slider = this.el.querySelector('.js-stepper-slider')
    this.ui.$counts = [...this.el.querySelectorAll('.js-stepper-count')]
    this.ui.$link = this.el.querySelector('.js-stepper-link')
    this.ui.$status = document.getElementById('stepper-status') // Span pour l'annonce vocale
    this.overlay = document.querySelector('.js-overlay-discover')
  }

  bindEvents() {
    this.ui.$minus.addEventListener('click', this.onMinus.bind(this))
    this.ui.$plus.addEventListener('click', this.onPlus.bind(this))
  }

  updateStatusMessage(count) {
    if (this.ui.$status) {
      const activeItem = this.el.querySelector(`[data-count="${count}"]`)
      if (activeItem) {
        this.ui.$status.textContent = activeItem.getAttribute('data-status-label')
      }
    }
  }

  onMinus() {
    let activeCountEl = this.el.querySelector('.js-stepper-count.is-active')
    if (!activeCountEl) return
    let count = parseInt(activeCountEl.textContent)

    this.ui.$counts.forEach(item => {
      item.classList.remove('is-active')
    })
    
    this.ui.$plus.classList.remove('is-disable')

    if (count == this.min) return

    if (count > this.min) {
      count -= this.inc
      this.translate = 80

      if (count == this.min) {
        this.ui.$minus.classList.add('is-disable')
        this.translate = 0
      }
    
      this.ui.$slider.style.transform = `translate3d(0, ${this.translate == 0 ? this.translate : -this.translate}px, 0)`
      this.el.querySelector(`[data-count="${count}"]`).classList.add('is-active')
      this.ui.$link.setAttribute('data-parent-id', `parent-discover-${count}`)
      
      this.updateStatusMessage(count)
    }
}

onPlus() {
  let activeCountEl = this.el.querySelector('.js-stepper-count.is-active')
  if (!activeCountEl) return // Vérifie qu'un élément actif existe
  let count = parseInt(activeCountEl.textContent)

  this.ui.$counts.forEach(item => {
      item.classList.remove('is-active')
  })

  this.ui.$minus.classList.remove('is-disable')

  if (count == this.max) return

  if (count < this.max) {
      count += this.inc
      this.translate = 80
      
      if (count == this.max) {
          this.ui.$plus.classList.add('is-disable')
          this.translate = this.translate * 2
      }

      this.ui.$slider.style.transform = `translate3d(0, -${this.translate}px, 0)`
      let newActiveEl = this.el.querySelector(`[data-count="${count}"]`)
      if (newActiveEl) {
          newActiveEl.classList.add('is-active')
      }
      this.ui.$link.setAttribute('data-parent-id', `parent-discover-${count}`)
      
      this.updateStatusMessage(count) // Mise à jour du message vocal
  }
}

}

export default Stepper;
